import MultipleImages from '../../../../assets/MultipleImages.png'
import styled from "@emotion/styled";

const ButtonContainer =styled.div({
    width:'22px',
    height:'22px',
    display:'flex',
   justifyContent:'center',
   alignItems:'center',

})


const Button =styled.button({
    display:'flex',
    width:'100%',
    height:'100%',
    background:'none',
    border:'none'
 })

export default function MultipleImagesButton({Multimode}){

    return(
          <ButtonContainer>
            <Button type="button" onClick={Multimode}>
                <img src={MultipleImages} alt=''/>
            </Button>
          </ButtonContainer>
 
     
    )
}
